import React, { useContext, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { ApplicationContext } from "../../../components/ApplicationProvider";
import { Banner, ConfigureButton } from "./SharedBannerStyle";
import { PATHS } from "../../../Routes";
import SsoBannerSVG from "../../../images/sso_banner.svg";
import { useCompanyAsAdminQuery } from "../../../graphql";
import { CREATE_EVENT } from "../../../graphql/Mutations/Event";
import { useMutation } from "@apollo/client";
import {
    EventCategory,
    METRIC_EVENT_CATALOG,
    MetricEventKey,
} from "@grabcad/company-server-shared/dist/types";

interface SsoBannerProps {
    eligibleForSSO: boolean;
}

const SsoBanner: React.FC<SsoBannerProps> = ({ eligibleForSSO }) => {
    const { t } = useContext(ApplicationContext);
    const history = useHistory();
    const { company } = useCompanyAsAdminQuery();
    const [triggerCreateEvent] = useMutation(CREATE_EVENT);

    const handleConfigureClick = useCallback(() => {
        // Navigate immediately
        history.push({
            pathname: PATHS.editCompany,
            state: eligibleForSSO ? { activeTab: 1 } : {},
        });

        // Fire-and-forget event logging (won’t block navigation)
        if (company?.id && !company.internal) {
            const { action, description } =
                METRIC_EVENT_CATALOG[MetricEventKey.CONFIGURE_SSO_FROM_BANNER];

            void triggerCreateEvent({
                variables: {
                    events: [
                        {
                            event: EventCategory.GC_CONTROL,
                            action,
                            description,
                        },
                    ],
                    companyId: company.id,
                },
            }).catch((err) => {
                console.error("Failed to log SSO configure event:", err);
            });
        }
    }, [history, company, triggerCreateEvent, eligibleForSSO]);

    return (
        <Banner background={SsoBannerSVG} data-testid="sso-banner">
            <div className="banner">
                <div className="text-section">
                    <h4>{t("homepage.sso_feature.sso_new")}</h4>
                    <h1>{t("homepage.sso_feature.sso_available")}</h1>
                </div>
                <ConfigureButton
                    style={{ color: "white" }}
                    onClick={handleConfigureClick}
                    data-testid="configure-sso-button"
                >
                    {t("homepage.sso_feature.configure_sso")}
                </ConfigureButton>
            </div>
        </Banner>
    );
};

export default SsoBanner;
